'use strict';

angular.module('front')
    .controller('FrontPageController', function() {
        var vm = this;
    });
